import  { useEffect, useState } from 'react'
import Select from 'react-select'
import { CForm, CFormLabel, CFormInput, CButton, CRow, CCol, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from '@coreui/react'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import toast from 'react-hot-toast'
import RegisterUser from '../../../src/services/general/register.api.js'
import providerCredentialingCRUD from '../../services/general/ProviderCredentialingCRUD.api.js'
import { buildCredentialingTemplate } from './kanban-components/credentialingutility'

const ProviderAddForm = ({ providerID, selectedRow, getDataListProvider, setSelectedRow, setselectProviderDetails, selectedDetails, formVisible, onClose }) => {
  const [activeTab, setActiveTab] = useState('facility')
  const [name, setName] = useState('')
  const [gender, setGender] = useState('Male')
  const [selectedUser, setSelectedUser] = useState('')
  const [dob, setDob] = useState('')
  const [address, setAddress] = useState('')
  const [facilityToDelete, setFacilityToDelete] = useState(null)
const [isNewFacilityAdded, setIsNewFacilityAdded] = useState(false)
const [newlyAddedFacility, setNewlyAddedFacility] = useState(null)
  const [cap, setCap] = useState(() => {
    try {
      const data = selectedDetails?.Details?.ProviderData
      const parsed = data && data !== 'undefined' ? JSON.parse(data) : {}
      return parsed?.Cap || 0
    } catch (error) {
      console.error('Failed to parse ProviderData:', error)
      return 0
    }
  })
  const [insuranceList, setInsuranceList] = useState([])
  const [loading, setLoading] = useState(true)
  const [facilityList, setFacilityList] = useState([])
  const [selectedFacility, setSelectedFacility] = useState('')
  const [availableDays, setAvailableDays] = useState([])
  const [selectedDays, setSelectedDays] = useState([])
  const [addedFacilities, setAddedFacilities] = useState([])
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [addedInsurances, setAddedInsurances] = useState([])
  const [contractStartDate, setContractStartDate] = useState('')
  const [selectedEditFacility, setSelectedEditFacility] = useState(null)
  const [selectedCredentialed, setSelectedCredentialed] = useState('Yes')
  const [allRegisteredUsers, setAllRegisteredUsers] = useState([]) 
  const [selectedOption, setSelectedOption] = useState({})
  const genderSelectOptions = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Other', label: 'Other' },
  ]
  const [selectedGenderOption, setSelectedGenderOption] = useState(null)
  const [selectedFacilityOption, setSelectedFacilityOption] = useState(null)
  const [deleteFacilityVisible, setDeleteFacilityVisible] = useState(false)
 

  const getData = async () => {
    setLoading(true)
    let facilityDetails = await FacilityCRUD('SELECT', {})
    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = JSON.parse(insuranceData.d)?.Data
    // Extract unique insurance types
    const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((ins) => ins.Type)))

    setInsuranceList(insuranceData)
    setInsuranceTypes(uniqueInsuranceTypes)
    facilityDetails = JSON.parse(facilityDetails.d)?.Data
    console.log('facilityDetails', facilityDetails)
    setFacilityList(facilityDetails)
    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, [providerID])

  useEffect(() => {
    document.body.classList.toggle('provider-facility-delete-active', deleteFacilityVisible)

    return () => {
      document.body.classList.remove('provider-facility-delete-active')
    }
  }, [deleteFacilityVisible])

  const GetAllUsers = async () => {
    const response = await RegisterUser('', '', '', '', 'get_all')
    let allUsers = response?.d
    allUsers = allUsers.Users
    if (allUsers.length > 0) {
      allUsers = allUsers.map((item) => {
        return {
          id: item.Id,
          name: item.Username,
        }
      })
      setAllRegisteredUsers(allUsers)
    }
  }
  useEffect(() => {
    GetAllUsers()
  }, [])

  useEffect(() => {
    if (gender) {
      const genderOption = genderSelectOptions.find((opt) => opt.value === gender)
      setSelectedGenderOption(genderOption || null)
    }
  }, [gender])

  useEffect(() => {
    if (selectedDetails && selectedDetails.Details) {
      const details = selectedDetails.Details
      setName(details.Name || '')
      setSelectedUser(details.UserId || '')
      setGender(details.Gender || 'Male')
      setDob(details.DOB || '')
      setAddress(details.Address || '')

      const insurances = selectedDetails.Insurances.map((insurance) => {
        const matchedInsurance = insuranceList.find((ins) => {
          if (ins.ID == insurance.InsuranceID) {
            return ins
          }
        })
        return {
          ID: matchedInsurance?.ID,
          Type: matchedInsurance?.Type,
          SubType: matchedInsurance?.SubType,
          Credentialed: insurance.Credentialed == 'true' ? true : false,
        }
      })
      setAddedInsurances(insurances)
    
      const facilities = selectedDetails.facilities.map((facility) => ({
        facilityID: facility.FacilityID,
        days: facility.Days ? facility.Days.split(',').map((day) => day.trim()) : [],
        Credentialed: facility.Credentialed,
      }))
      setAddedFacilities(facilities)
    }
  }, [selectedDetails, insuranceList])

  const handleFacilitySelect = (selectedOption) => {
    if (selectedOption) {
      setSelectedFacilityOption(selectedOption)
      setSelectedFacility(selectedOption.value)
      const facility = facilityList.find((fac) => String(fac.ID) === String(selectedOption.value))
      if (facility) {
        const days = facility.Days ? facility.Days.split(',').map((day) => day.trim()) : []
        setSelectedDays(days)
        setAvailableDays(days)
      } else {
        setAvailableDays([])
      }
    } else {
      setSelectedFacilityOption(null)
      setSelectedFacility('')
      setAvailableDays([])
    }
  }

 

const handleAddFacility = () => {
  if (!selectedFacility) {
    toast.error('Please select a facility first')
    return
  }

  const selectedFacilityId = String(selectedFacility)
  const isDuplicate = addedFacilities.some((facility, index) => {
    const isSameFacility = String(facility.facilityID) === selectedFacilityId
    if (selectedEditFacility !== null && selectedEditFacility !== undefined) {
      return isSameFacility && index !== selectedEditFacility
    }
    return isSameFacility
  })

  if (isDuplicate) {
    toast.error('This facility is already added to the list')
    return
  }

  const newFacility = {
    facilityID: selectedFacility,
    days: selectedDays,
    Credentialed: selectedCredentialed,
  }

  if (selectedEditFacility !== null && selectedEditFacility !== undefined) {
    const updatedFacilities = [...addedFacilities]
    updatedFacilities[selectedEditFacility] = newFacility

    setAddedFacilities(updatedFacilities)
    setSelectedEditFacility(null)
  }  else {
    setAddedFacilities((prev) => [...prev, newFacility])
  setNewlyAddedFacility(newFacility)
  setIsNewFacilityAdded(true)
}

  setSelectedFacility('')
  setSelectedFacilityOption(null)
  setAvailableDays([])
  setSelectedDays([])
  setSelectedCredentialed('Yes')
}
const createCredentialingTasks = async (
  providerId,
  providerName
) => {

  
  try {
    // Get login user information for task assignment
    let loginUserId = ''
    let loginUsername = ''
    
    try {
      const userLoginData = localStorage.getItem('userLoginWithCredentials')
      const userData = localStorage.getItem('user')
      
      if (userData) {
        const parsedUser = JSON.parse(userData)
        loginUserId = parsedUser?.Id || parsedUser?.id || ''
      }
      
      if (userLoginData) {
        const parsedLogin = JSON.parse(userLoginData)
        loginUsername = parsedLogin?.phoneNo || parsedLogin?.username || loginUserId
      }
    } catch (err) {
      console.warn('Could not retrieve login user info:', err)
    }

  console.log("newlyAddedFacility", newlyAddedFacility)

const nonCredentialedFacilities =
  newlyAddedFacility &&
  newlyAddedFacility.Credentialed === 'In Progress'
    ? [newlyAddedFacility]
    : []

console.log("Facilities to create tasks for", nonCredentialedFacilities)

    if (
      nonCredentialedFacilities.length === 0
    ) {
      return []
    }

    
    const createdTasks = []
console.log('Creating credentialing tasks for provider:',nonCredentialedFacilities)
    for (const facility of nonCredentialedFacilities) {
      const facilityData =
        facilityList.find(
          (f) =>
            String(f.ID) ===
            String(
              facility.facilityID
            )
        )

  

      if (!facilityData) continue
console.log('Creating task for facility:', facilityData)
      const credentialTemplate = buildCredentialingTemplate({
        FacilityName: facilityData.Name,
        FacilityID: facility.facilityID,
        ProviderID: providerId,
        ProviderName: providerName,
        Description: facilityData.Type,
      })
      const taskPayload = {
        Title: `${facilityData.Name}`,
        Description: `${facilityData.Type}`,
        TaskType: 'Credentialing',
        FacilityID:
          facility.facilityID,
        FacilityName:
          facilityData.Name,
        ProviderID: providerId,
        ProviderName: providerName,
        Status: 'To Do',
        Priority: 'Medium',
        // Assign task to login user
        AssignedTo: loginUserId || '',
        AssignedUsersJson: loginUserId ? [{
          UserId: loginUserId,
          Username: loginUsername,
          value: loginUserId,
          label: loginUsername,
        }] : [],
        subtask: credentialTemplate.subtasks || [],
        SubtasksJson: credentialTemplate.subtasks || [],
      }

      const existingTasks = await providerCredentialingCRUD(
  '',
  providerId,
  'SELECT'
)

const parsed =
  typeof existingTasks?.d === 'string'
    ? JSON.parse(existingTasks.d)
    : existingTasks

const allTasks = parsed?.Data || []

const alreadyExists = allTasks.some(
  (task) =>
    String(task.provider_id) === String(providerId) &&
    String(task.facility_id) === String(facility.facilityID) &&
    !['Completed', 'Archived'].includes(task.status)
)

if (alreadyExists) {
  continue
}

    await providerCredentialingCRUD(      
        JSON.stringify(taskPayload),  '',  'INSERT'
      )


      createdTasks.push(taskPayload)
    }

    return createdTasks
  } catch (error) {
    console.error(
      'Credentialing task creation failed:',
      error
    )

    return []
  }
}

  const getCoordinates = async (addr) => {
    const geocoder = new window.google.maps.Geocoder()
    let latlong = {}
    try {
      await geocoder.geocode({ address: addr }, (results, status) => {
        if (status === 'OK') {
          const latLng = results[0].geometry.location
          let allAddress = results[0]['address_components']
          let addressDetails = {}

          allAddress.map((obj) => {
            let l = obj['types'][0]
            addressDetails[l] = obj['long_name']
          })

          latlong = { lat: latLng.lat(), lng: latLng.lng(), addressDetails, city: addressDetails['locality'] }
        } else {
          latlong = { lat: null, lng: null, addressDetails: null, city: null }
        }
      })
    } catch (e) {
      let a = ''
    }

    return latlong
  }

  // Sort facility list alphabetically
  const sortedFacilities = [...facilityList].sort((a, b) => {
    const nameA = (a.Name || '').trim().toLowerCase()
    const nameB = (b.Name || '').trim().toLowerCase()
    return nameA.localeCompare(nameB)
  })
console.log('sortedFacilities',sortedFacilities)
  // Map facilityID → Name safely and sort
  const sortedAddedFacilities = [...addedFacilities].sort((a, b) => {
    const nameA = (facilityList.find((f) => String(f.ID) === String(a.facilityID))?.Name || '').trim().toLowerCase()
    const nameB = (facilityList.find((f) => String(f.ID) === String(b.facilityID))?.Name || '').trim().toLowerCase()
    return nameA.localeCompare(nameB)
  })
console.log('sortedAddedFacilities',sortedAddedFacilities)
  const onClear = () => {
    setSelectedFacility(null)
    setSelectedFacilityOption(null)
    setAvailableDays([])
    setSelectedDays([])
    setSelectedEditFacility(null)
    setSelectedCredentialed('Yes')
    setName('')
    setGender('Male')
    setSelectedGenderOption(null)
    setDob('')
    setAddress('')
    setInsuranceList([])
    setSelectedRow({})
    setselectProviderDetails({})
    onClose()
  }

const handleSubmit = async () => {
  try {
    let insurances = addedInsurances.map((ins) => ({
      InsuranceID: ins.ID,
      Type: ins.Type,
      Name: ins.SubType,
      Credentialed: ins.credentialed || false,
    }))

    let facility = addedFacilities.map((facility) => ({
      FacilityID: facility.facilityID,
      Days: facility.days.join(', '),
      Credentialed: facility.Credentialed,
    }))

    let latlong = await getCoordinates(address)

    const providerData = {
      Name: name,
      Gender: gender,
      DOB: dob,
      UserId: selectedUser,
      Address: address,
      contractStartDate,
      AddressDetails: JSON.stringify(
        latlong?.addressDetails
      ),
      Lat: latlong?.lat,
      Lng: latlong?.lng,
      Insurances: JSON.stringify(insurances),
      Facilities: JSON.stringify(facility),
      ProviderData: JSON.stringify({
        Cap: cap,
      }),
    }

    let providerId = null

    if (selectedRow?.ID) {
      await fetchPatientData(
        'UPDATE',
        'Provider',
        JSON.stringify({
          ...providerData,
          ID: selectedRow.ID,
        })
      )

      providerId = selectedRow.ID
    } else {
      const response = await fetchPatientData(
        'INSERT',
        'Provider',
        JSON.stringify(providerData)
      )

      providerId =
        JSON.parse(response.d)?.ID
    }

  const createdTasks = await createCredentialingTasks(providerId, name)
  setNewlyAddedFacility(null)
setIsNewFacilityAdded(false)
  const shouldRedirectToCredentialing =
    isNewFacilityAdded &&
    Array.isArray(createdTasks) &&
    createdTasks.length > 0

  if (shouldRedirectToCredentialing) {
    window.location.href = `/home/credentialing?providerId=provider-${providerId}`
  } else {
    onClear()
  }
    getDataListProvider()
  } catch (error) {
    console.error(error)
    toast.error(
      'Failed to save provider'
    )
  }
}

  const handleRemoveFacility = (facility) => {
     setFacilityToDelete(facility)
    setDeleteFacilityVisible(true)
  }

const confirmDeleteFacility = () => {
  if (!facilityToDelete) return

  setAddedFacilities(prev =>
    prev.filter(
      item =>
        !(
          String(item.facilityID) === String(facilityToDelete.facilityID) &&
          String(item.Credentialed) === String(facilityToDelete.Credentialed)
        )
    )
  )

  setDeleteFacilityVisible(false)
  setFacilityToDelete(null)
}

  useEffect(() => {
    if (allRegisteredUsers.length > 0 && selectedUser) {
      const selectedOption = allRegisteredUsers.find((user) => user.name === selectedUser) //
      if (selectedOption) {
        setSelectedOption({ value: selectedOption?.id, label: selectedOption?.name })
      }
    }
  }, [selectedUser, allRegisteredUsers])

const handleEditFacility = (facility, index) => {
  setSelectedEditFacility(index)

  const Findfacility = facilityList.find(
    (fac) => String(fac.ID) === String(facility.facilityID)
  )

  if (!Findfacility) {
    toast.error('Facility not found')
    return
  }

  setSelectedFacility(Findfacility.ID)
  setSelectedFacilityOption({
    value: Findfacility.ID.toString(),
    label: Findfacility.Name,
  })

  setSelectedCredentialed(facility.Credentialed)
}



    const credentialOption = [
    { value: 'Yes', label: 'Yes' },
      { value: 'In Progress', label: 'In Progress' },
     { value: 'No', label: 'No' },
  ]

  return (
    
    <CModal size="lg" backdrop={'static'} scrollable visible={formVisible} onClose={onClear} className="dashboard-dark-modal provider-credentialing-modal">
      <CModalHeader className={deleteFacilityVisible ? 'provider-modal-layer-blur' : ''} onClose={onClear}>
        <CModalTitle>{selectedRow.Name ? 'Edit Credentialing' : 'Add Provider'}</CModalTitle>
      </CModalHeader>
      <CModalBody className={deleteFacilityVisible ? 'provider-modal-layer-blur' : ''}>
        {/* <CNav className="justify-content-center" variant="pills">
          <CNavItem>
            <CNavLink active={activeTab === 'personalDetails'} onClick={() => setActiveTab('personalDetails')}>
              Personal Details
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeTab === 'insurance'} onClick={() => setActiveTab('insurance')}>
              Insurance
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeTab === 'facility'} onClick={() => setActiveTab('facility')}>
              Facility
            </CNavLink>
          </CNavItem>
        </CNav> */}

        <CTabContent>
          {/* <CTabPane visible={activeTab === 'personalDetails'}>
            <CForm>
              <CRow className="mb-3">
                <CCol xs="6">
                  <CFormLabel>Name</CFormLabel>
                  <CFormInput type="text" placeholder="Enter name" value={name} onChange={(e) => setName(e.target.value)} />
                </CCol>
                <CCol xs="6">
                  <CFormLabel>Gender</CFormLabel>
                  <Select
                    options={genderSelectOptions}
                    value={selectedGenderOption}
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        setGender(selectedOption.value)
                        setSelectedGenderOption(selectedOption)
                      } else {
                        setGender('Male')
                        setSelectedGenderOption(null)
                      }
                    }}
                    className="basic-single-select"
                    classNamePrefix="select"
                    isClearable
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol xs="6">
                  <CFormLabel>Date of birth</CFormLabel>
                  <CFormInput type="date" value={dob} onChange={(e) => setDob(e.target.value)} />
                </CCol>
                <CCol xs="6">
                  <CFormLabel>Address</CFormLabel>
                  <CFormInput type="text" placeholder="Enter address" value={address} onChange={(e) => setAddress(e.target.value)} />
                </CCol>

                <CCol className="mt-3" xs="6">
                  <CFormLabel>CAP</CFormLabel>
                  <CFormInput type="text" placeholder="Enter CAP" value={cap} onChange={(e) => setCap(e.target.value)} />
                </CCol>
                <CCol className="mt-3" xs="6">
                  <CFormLabel>Contract Start Date</CFormLabel>
                  <CFormInput type="date" placeholder="Enter name" value={contractStartDate} onChange={(e) => setContractStartDate(e.target.value)} />
                </CCol>
                <CCol className="mt-3" xs="6">
                  <div className="">
                    <CFormLabel>Select Users</CFormLabel>
                    <Select
                      value={selectedOption ? selectedOption : null}
                      placeholder="Select Users"
                      name="status"
                      options={allRegisteredUsers.map((user) => ({ value: user.id, label: user.name }))}
                      onChange={(e) => {
                        setSelectedUser(e.label)
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </CTabPane>

          <CTabPane visible={activeTab === 'insurance'}>
            <InsuranceTab addedInsurances={addedInsurances} setAddedInsurances={setAddedInsurances} selectedDetails={selectedDetails} insuranceList={insuranceList} insuranceTypes={insuranceTypes}></InsuranceTab>
          </CTabPane> */}

          <CTabPane visible={activeTab === 'facility'}>
            <CForm>
              <CRow className="mb-3 mt-3  ">
                <CCol xs="6">
                  <CFormLabel>Facility</CFormLabel>
                  <Select
                    options={sortedFacilities.map((facility) => ({
                      value: facility.ID.toString(),
                      label: facility.Name,
                    }))}
                    value={selectedFacilityOption}
                    onChange={handleFacilitySelect}
                    isClearable
                    placeholder="Select Facility"
                    className="basic-single-select"
                    classNamePrefix="select"
                  />
                </CCol>
                <CCol xs="6">
                  <CFormLabel>Credentialed ? </CFormLabel>
                  <Select
                    options={credentialOption}
                    value={credentialOption.find((opt) => opt.value === selectedCredentialed)}
                    onChange={(selectedOption) => {
                      setSelectedCredentialed(selectedOption.value)
                    }}
                    className="basic-single-select"
                    classNamePrefix="select"
                  />
                </CCol>

                {/* <CCol xs="6">
                  <CFormLabel>Days</CFormLabel>
                  <CFormSelect multiple value={selectedDays} onChange={handleDaysSelect}>
                    {availableDays.map((day, index) => (
                      <option key={index} value={day}>
                        {day}
                      </option>
                    ))}
                  </CFormSelect>
                </CCol> */}
              </CRow>
              <CRow>
                <CCol xs="12">
                  <div className="d-flex justify-content-center">
                    <CButton color="primary" onClick={handleAddFacility} disabled={!selectedFacility}>
                      {selectedEditFacility !== null && selectedEditFacility !== undefined ? 'Update Facility' : 'Add '}
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>

            {addedFacilities.length > 0 && (
              <CTable striped className="mt-3 provider-credentialing-table">
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>Facility</CTableHeaderCell>
                 
                    <CTableHeaderCell className="text-end">Action</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {sortedAddedFacilities.map((facility, index) => {
                    const facilityName = facilityList.find((fac) => String(fac.ID) === String(facility.facilityID))?.Name || 'Unknown'
                    return (
                      <CTableRow key={index}>
                        <CTableDataCell valign="middle">
  {facility.Credentialed === 'Yes' ? (
    <span
      className="m-1"
      style={{
        border: '1px solid #0deb0d',
        padding: '1.5px',
        backgroundColor: '#0deb0d',
        borderRadius: '7px',
      }}
    />
  ) : facility.Credentialed === 'In Progress' ||
    facility.Credentialed === 'Credentialing (In Progress)' ? (
    <span
      className="m-1"
      style={{
        border: '1px solid yellow',
        padding: '1.5px',
        backgroundColor: 'yellow',
        borderRadius: '7px',
      }}
    />
  ) : (
    <span
      className="m-1"
      style={{
        border: '1px solid red',
        padding: '1.5px',
        backgroundColor: 'red',
        borderRadius: '7px',
      }}
    />
  )}{' '}
  <span className="facility-name-text">{facilityName}</span>
</CTableDataCell>
                      
                        <CTableDataCell valign="middle" className="d-flex justify-content-end gap-2">
                          <CButton variant="outline" className="" size="sm" color="warning" onClick={() => {
  const originalIndex = addedFacilities.findIndex(
    f =>
      String(f.facilityID) === String(facility.facilityID) &&
      String(f.Credentialed) === String(facility.Credentialed)
  )

  handleEditFacility(facility, originalIndex)
}}>
                            Edit
                          </CButton>
                          <CButton variant="outline" className="" size="sm" color="danger" onClick={() => {  handleRemoveFacility(facility)
}}>
                            Delete
                          </CButton>
                        </CTableDataCell>
                      </CTableRow>
                    )
                  })}
                </CTableBody>
              </CTable>
            )}
          </CTabPane>
        </CTabContent>
      </CModalBody>
      <CModalFooter className={`d-flex justify-content-center${deleteFacilityVisible ? ' provider-modal-layer-blur' : ''}`}>
        <CButton color="primary" onClick={handleSubmit}>
          Submit
        </CButton>
      </CModalFooter>

      <CModal className="facility-delete-confirm-modal" visible={deleteFacilityVisible} onClose={() => setDeleteFacilityVisible(false)} centered backdrop={'static'}>
        <CModalHeader onClose={() => setDeleteFacilityVisible(false)}>
          <CModalTitle>Delete Facility</CModalTitle>
        </CModalHeader>
        <CModalBody>
          Are you sure you want to delete this facility?
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" variant="outline" onClick={() => setDeleteFacilityVisible(false)}>
            Close
          </CButton>
          <CButton color="danger" variant="outline" onClick={confirmDeleteFacility}>
            Delete
          </CButton>
        </CModalFooter>
      </CModal>
    </CModal>

   
  )
}

export default ProviderAddForm
